var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Shop Sales","items":_vm.items}},[_c('OrderDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }